import React from "react"
import ExpoLogoSec from "../defaults/assets/logos/expo_sec_blk_rgb.svg"
import {
  Aboutenergy,
  Accure,
  Actasys,
  Actyx,
  Andcharge,
  Arkite,
  Artimus,
  Asvin,
  Atlatec,
  Audvice,
  Autol,
  Bareways,
  Beond,
  Bia,
  Brodmann17,
  Brytlyt,
  Canatu,
  Cargocube,
  Celus,
  Certivity,
  Chargylize,
  Cirqua,
  Circuitbooking,
  Coolingphotonics,
  Covision,
  Deepfine,
  Deskbird,
  Difon,
  Edgelesssystems,
  Excelfore,
  Filics,
  Flip,
  Forciot,
  Foursilence,
  Griiip,
  Highmobility,
  Hyperganic,
  Hypermile,
  Identifai,
  Maaind,
  Makersite,
  Mercanis,
  Monolith,
  Mopic,
  Neurocontrols,
  Nevaxr,
  Newtwen,
  Noderobotics,
  Nxrt,
  Oculavis,
  Opinum,
  Peregrineai,
  Phononicvibes,
  Poen,
  Pullsystems,
  Roadtravel,
  Routekonnect,
  S1seven,
  Scopetechnology,
  Sensemore,
  Sevenbel,
  Shipzero,
  Smartaudio,
  Smartix,
  Sparetech,
  Spinque,
  Sonatus,
  Sonobeacon,
  Spreadai,
  Synthesia,
  Swipeguide,
  Trieye,
  Truckoo,
  Twoelectron,
  Ubq,
  Ventus,
  Venuex,
  Vianova,
  Wayahead,
  Wheelme,
  Wondermove,
  Yolda,
  Fourscreen,
} from "../defaults/assets/logos/startuplogos/index"

const StartupIcons = {
  rec0QC9f8KTw7TpqX: Foursilence,
  recMLKQo9MV6iV7hv: Aboutenergy,
  reci3juaGa0oSYczU: Accure,
  recZdktW4QEQkL4o3: Actasys,
  recHavE0MhJ0otmhy: Actyx,
  recAGXuQyC8niO0GX: Andcharge,
  recQp8ZtUvYeFox9b: Artimus,
  recEOtZGLDUN4sP6j: Arkite,
  recxQat1yV7FQXulA: Asvin,
  recejwfJVMmhXJdUT: Atlatec,
  receHbM1KlRtxqHYm: Audvice,
  recxkVmtHe6I49bNG: Autol,
  recBfinNz3uimsYLi: Bareways,
  recIZwC6v8qoQfyVH: Beond,
  recIEXaNUEzqJmK5r: Bia,
  // b: Beeplanet,
  // rec9qFe30zZSHrtbw: Bestmile,
  // b: Brighterai,
  recw5OfJVJ2dVfSmm: Brodmann17,
  recJhozTI8bCOJizB: Brytlyt,
  recFSu5WjmPGAlszk: Canatu,
  rec5hk9WeI9nnMpBL: Cargocube,
  recOBjhvHF1HxKjCH: Celus,
  recd54LCKOh85ZPTi: Certivity,
  recBTd4g8BWf0Ogrp: Chargylize,
  recbefRGfZHSBjgRL: Circuitbooking,
  rec9gSAssj8qj71dO: Cirqua,
  recN6WRz1Er6xj4Ig: Coolingphotonics,
  recWtAQNjXNzcmW0y: Covision,
  // b: Cybellum,
  recnWZAp0UhyN9FD0: Deepfine,
  recf7wBHCyvhIHjHY: Deskbird,
  recxNfqqQxBxPw5C7: Difon,
  // b: Deliciousdata,
  // b: Designled,
  // b: Drishti,
  // b: Dycotec,
  recJXS653xYFxkbCt: Edgelesssystems,
  reclWHOXPlhbcXJE4: Excelfore,
  recDyKMXNBestBiCs: Filics,
  rec5Ru6wCM4FF6OjY: Flip,
  reck96PQxfU6wkay6: Forciot,
  rec5qCwoB4C2yD4KQ: Fourscreen,
  // b: Embold,
  // b: Endel,
  // b: Excelfore,
  // b: Germanautolabs,
  // b: Gestoos,
  recilikB7FMSThwYI: Griiip,
  recBBXybOLaSaJ2tU: Highmobility,
  recldyeZPgyukxQAq: Hyperganic,
  rec2l0Gqoi4c323tg: Hypermile,
  recqUda5uXlU2FjXA: Identifai,
  // b: Kontrol,
  recMq09ym6NrPuxdy: Maaind,
  recL8bR55dUcWNFTu: Makersite,
  recEl4yvEH0knRNzq: Mercanis,
  recZ8qRqxcNSgT5eM: Monolith,
  rec6yxkJQwR0vxNqT: Mopic,
  recIaDz04tejo5ikE: Neurocontrols,
  recosXyzjfLE6qOSU: Nevaxr,
  reczGnavZdDNk7Nzn: Newtwen,
  recsCxmUh2LGBbNhn: Noderobotics,
  // b: Nodar,
  reco8gwiBfT9NrV0g: Nxrt,
  // b: Peakboard,
  // b: Polymertal,
  // b: Planco,
  // b: Preact,
  recY2H9p2trhPGpAc: Oculavis,
  recAYv2XHNrOgmKJZ: Opinum,
  recKdU1kag7Fr8b3K: Peregrineai,
  recPHXzBBWflVeQyl: Poen,
  recPOL2JpZW7uucKU: Pullsystems,
  recShKEkAQHWz3oXR: Roadtravel,
  recK046CrY7An1XQk: Routekonnect,
  recLHERUwGx8lLHgX: Phononicvibes,
  recToge4RDpIpG02O: S1seven,
  recx31eYq6O3oQyC3: Scopetechnology,
  // b: Sensel,
  recD0smyW5LFSDJVF: Sensemore,
  recZsbSCIYwaLuV7l: Sevenbel,
  recTPcKPNhd6RKpyZ: Shipzero,
  reccT4EpsrOm3sd2i: Smartaudio,
  recWBfxe9PzAJzvT0: Smartix,
  recgvsRjm67e557vY: Sonatus,
  recMqeT4M3iDB5Szk: Sonobeacon,
  rec5bNAsAZKyqtNTm: Sparetech,
  recbcj7xHLMXv5Fmf: Spreadai,
  recBIourAP0H9xucN: Spinque,
  // b: Spreadai,
  recpjVWkP2zV0zt62: Swipeguide,
  recHlIj3spiYqZ3mG: Synthesia,
  // b: Terranet,
  // b: Textia,
  recGipLG1sqyvRS98: Trieye,
  recDWbBf8GMd0kZih: Truckoo,
  recJRnFSR6uvilSTQ: Twoelectron,
  recDGIj4HRBRvnR8M: Ubq,
  // b: Vencortex,
  recvFLuLbyqsm51Pn: Ventus,
  rec6EMvpq2kPR68a4: Venuex,
  recAq9WlUXflky9ZS: Vianova,
  // b: Viezo,
  recx6otpEDkBJdglH: Wayahead,
  rec5jYg25xUzpod2z: Wheelme,
  recMc2Fgda6CxWPqI: Wondermove,
  // b: Yuri,
  recgHafEi8VHHiEjG: Yolda,
}

const StartupLogo = ({ id }) => {
  let Icon = undefined

  if (StartupIcons[id] !== undefined) {
    Icon = StartupIcons[id]
  } else {
    Icon = ExpoLogoSec
  }
  return <>{Icon ? <Icon /> : ""}</>
}

export default StartupLogo
